import React from "react";
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

export default function SelectTypeTripCart2(props) {
  const {
    isOpen1,
    setIsOpen1,
    name,
    label,
    value,
    error = null,
    onChange,
    options,
  } = props;

  return (
    <FormControl
      variant="outlined"
      {...(error && { error: true })}
      className="add-passenger"
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        className="selectradius"
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        open={isOpen1}
        onClose={() => {
          setIsOpen1(false);
        }}
        onOpen={() => {
          setIsOpen1(true);
        }}
      >
        {options.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
            style={{ display: "flex", justifyContent: "space-around" }}
          >
            {item.title}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
